// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".layout-config[data-v-00901177]{position:relative}.layout-config .extra[data-v-00901177]{position:absolute;right:10px;top:10px}.layout-config .research-news-content[data-v-00901177]{width:1000px;margin:0 auto}.layout-config .research-news[data-v-00901177]{text-indent:2em}", ""]);
// Exports
module.exports = exports;
